export const determineSectionCards = (roles, cards) => {
  const unprotectedCards = cards.filter(card => !('roles' in card));
  const protectedCards = cards.filter(
    card => Object.keys(roles).find(role => roles[role] && card.roles?.includes(role)) && card
  );

  return [...unprotectedCards, ...protectedCards];
};

export const openInNewTab = url => {
  window.open(url, '_blank', 'noopener,noreferrer');
};
